// CORRIGIDO EM 02/09/2026: o app chamava register() (o padrao antigo do Create
// React App), que instala um service worker e passa a servir o "app shell"
// (index.html + os bundles JS) direto do cache em toda navegacao seguinte —
// so' troca de verdade depois que TODAS as abas da pessoa forem fechadas e
// reabertas, e nada aqui avisava a pessoa disso (o evento 'updateAvailable'
// era disparado sem ninguem ouvir).
//
// Isso e' a causa real do link de "esqueci minha senha" caindo na tela de
// login: quem ja' tinha visitado o sistema ANTES da rota /redefinir-senha
// existir ficou com o app antigo preso no cache do navegador. Ao clicar no
// link (uma navegacao nova, de fora), o service worker respondia com o
// index.html antigo — cujo JS nem sabia que a rota /redefinir-senha existia
// — e o React Router antigo caia no fallback de sempre, o login.
//
// unregister() (chamado em src/index.js) resolve dos dois lados: desliga o
// service worker de quem ja' estava com um instalado (a partir da proxima
// visita esse navegador volta a buscar o index.html direto do servidor) e
// impede que isso se repita nos proximos deploys. O sistema nao precisa de
// uso offline — nao ha' motivo pra pagar esse preco.
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export default function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; please refresh.');
              window.dispatchEvent(new Event('updateAvailable'));
            } else {
              console.log('Content is cached for offline use.');
            }
          }
        };
      };

      registration.update();

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
            caches.keys().then(cacheNames => {
              return Promise.all(
                cacheNames.map(cacheName => {
                  return caches.delete(cacheName);
                })
              );
            });
          }
        });
      });
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}


function checkValidServiceWorker(swUrl) {
  fetch(swUrl)
    .then(response => {
      if (
        response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1
      ) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
